export const BOXES_FETCH_ALL_BOXES = 'BOXES_FETCH_ALL_BOXES'
